"use strict";
require('../../layouts/web-public');
require('venobox');
require('odometer');
// import gsap from '../../../plugins/gsap/gsap';

var IpixHomeWelcome = function () {

    $('.venobox').venobox();

    var initCarousels = function (e) {
        var postCarousalOptions = IpixJson.options.owlcarousel;
        postCarousalOptions.autoplay = false;
        postCarousalOptions.loop = false;
        postCarousalOptions.nav = false;
        postCarousalOptions.responsive = {
            0: { items: 1, dots: true },
            576: { items: 2 },
            1000: { items: 3 }
        };
        $('.post').owlCarousel(postCarousalOptions);

        var testimonalCarousalOptions = IpixJson.options.owlcarousel;
        testimonalCarousalOptions.autoplay = false;
        testimonalCarousalOptions.responsive = {
            0: { items: 1 },
            576: { items: 2 },
            1000: { items: 3 }
        };
        $('.testimonal').owlCarousel(testimonalCarousalOptions);

        var clientsCarousalOptions = IpixJson.options.owlcarousel;
        clientsCarousalOptions.autoplay = true;
        clientsCarousalOptions.autoplayTimeout = 3000;
        clientsCarousalOptions.loop = true;
        clientsCarousalOptions.responsive = {
            0: { items: 2 },
            400: { items: 3 },
            600: { items: 4 },
            1000: { items: 5 }
        };
        $('.clients').owlCarousel(clientsCarousalOptions);

        var productsSlideCarousalOptions = IpixJson.options.owlcarousel;
        productsSlideCarousalOptions.margin = 0;
        productsSlideCarousalOptions.dots = true;
        productsSlideCarousalOptions.autoplay = true;
        productsSlideCarousalOptions.stopOnHover = true;
        productsSlideCarousalOptions.responsive = {
            0: { items: 1 },
        };
        $('.products-slide').owlCarousel(productsSlideCarousalOptions);

        var mobileAppCarousalOptions = IpixJson.options.owlcarousel;
        mobileAppCarousalOptions.responsive = {
            0: { items: 2 },
            390: { items: 3 },
            767: { dots: false, loop:true },
            1000: { items: 4 },
            1200: { items: 5 }
        };
        mobileAppCarousalOptions.loop = false;
        mobileAppCarousalOptions.margin = 25;
        $('.mobile-app').owlCarousel(IpixJson.options.owlcarousel);


        var owlProductsCarousalOptions = IpixJson.options.owlcarousel;
        owlProductsCarousalOptions.margin = 25;
        owlProductsCarousalOptions.loop = true;
        owlProductsCarousalOptions.autoplay = true;
        owlProductsCarousalOptions.autoplaySpeed = 300;
        owlProductsCarousalOptions.responsive = {
            0: { items: 1, dots: true },
            600: { items: 2 },
            1200: { items: 4 },
        };
        $('.owl-products').owlCarousel(IpixJson.options.owlcarousel);
    }

    var handleServiceToggle = function (e) {
        $(".service-btn").click(function () {
            $(".services").addClass("service-detail");
        });
        $("#our_services_section").on("mouseleave", function () {
            if ($('.services').hasClass('service-detail')) {
                $('.services').removeClass('service-detail')
            }
        });

    }

    var initPageGSAP = function () {
        const element = document.getElementById('ipix_app_header');
        const timeline = gsap.timeline();
        timeline.from(element, { duration: 1, opacity: 0, y: 200 });
        timeline.play();

        let headings = gsap.utils.toArray(".js-title").reverse();
        headings.forEach((heading, i) => {
            let headingIndex = i + 1;
            let mySplitText = new SplitText(heading, { type: "chars" });
            let chars = mySplitText.chars;

            chars.forEach((char, i) => {
                smoother.effects(char, { lag: (i + headingIndex) * 0.1, speed: 1 });
            });
        });

        // let splitTextLines = gsap.utils.toArray(".js-splittext-lines");

        // const tl = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: splitTextLines,
        //         start: 'top 90%',
        //         end: 'bottom 60%',
        //         scrub: 2,
        //         markers: false,
        //         toggleActions: 'play none play reset'
        //     }
        // });

        // const itemSplitted = new SplitText(splitTextLines, { type: 'lines' });
        // tl.from(itemSplitted.lines, { y: 100, opacity: 0, stagger: 0.05, duration: 0.5, ease: 'back.inOut' });
    }

    var serviceDetailsHandle = function () {
        $('.show-service-details').on("click", function () {
            const name = $(this).data("name");
            const description = $(this).data("description");
            const image = $(this).data("image");
            const slug = $(this).data('slug');
            $('#service-name').text(name);
            $('#service-desc').html(description);
            $('#service-img').prop('src', image);
            $('#service_href').prop('href', "/services/" + slug)
        });
    }

    var initCounters = function () {

        const counters = document.querySelectorAll('.counter');

        counters.forEach(counter => {
            counter.innerText = '0';
            IpixHomeWelcome.updateCounter(counter);
        });
    }

    // Public methods
    return {
        init: function () {
            // initPageGSAP();
            initCarousels();
            handleServiceToggle();
            initCounters();
            serviceDetailsHandle();
        }
    }



}();

// On document ready
IpixUtil.onDOMContentLoaded(function () {
    IpixHomeWelcome.init();
});

IpixHomeWelcome.updateCounter = function (counter) {
    const target = $(counter).data('target');
    const current = $(counter).text();
    const increment = target;
    if (current < target) {
        $(counter).text(`${Math.ceil(current + increment)}`);
        setTimeout(IpixHomeWelcome.updateCounter(), 1);
    } else {
        $(counter).text(target);
    }
}

var buttons = document.querySelectorAll('.service-btn-inner-click .show-service-details');

buttons.forEach(function (button) {
    button.addEventListener("click", function () {
        // Remove "active" class from all buttons
        buttons.forEach(function (btn) {
            btn.classList.remove("active");
        });

        // Add "active" class to the clicked button
        this.classList.add("active");

        // Get the data-name value of the clicked element
        var dataName = this.parentElement.getAttribute("data-name");

        // Add "active" class to elements with the same data-name
        var elementsWithSameDataName = document.querySelectorAll('[data-name="' + dataName + '"]');
        elementsWithSameDataName.forEach(function (element) {
            element.classList.add("active");
        });
    });
});
